'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var DryingMachine = function (_React$Component) {
    _inherits(DryingMachine, _React$Component);

    function DryingMachine() {
        _classCallCheck(this, DryingMachine);

        return _possibleConstructorReturn(this, (DryingMachine.__proto__ || Object.getPrototypeOf(DryingMachine)).apply(this, arguments));
    }

    _createClass(DryingMachine, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M22.469 3.217h-19.373c-1.704 0-3.096 1.392-3.096 3.096v19.373c0 1.704 1.392 3.096 3.096 3.096h19.401c1.704 0 3.096-1.392 3.096-3.096v-19.373c-0.028-1.704-1.42-3.096-3.125-3.096zM1.42 9.609v-3.153c0-0.909 0.739-1.676 1.676-1.676h19.401c0.909 0 1.676 0.739 1.676 1.676v3.153h-22.753zM23.577 25.686c0 0.597-0.483 1.108-1.108 1.108h-19.373c-0.597 0-1.108-0.483-1.108-1.108v-14.658h21.589v14.658z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M8.522 7.336c0 0.784-0.636 1.42-1.42 1.42s-1.42-0.636-1.42-1.42c0-0.784 0.636-1.42 1.42-1.42s1.42 0.636 1.42 1.42z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M14.203 7.336c0 0.784-0.636 1.42-1.42 1.42s-1.42-0.636-1.42-1.42c0-0.784 0.636-1.42 1.42-1.42s1.42 0.636 1.42 1.42z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M19.884 7.336c0 0.784-0.636 1.42-1.42 1.42s-1.42-0.636-1.42-1.42c0-0.784 0.636-1.42 1.42-1.42s1.42 0.636 1.42 1.42z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M10.539 17.193c-1.136 0-2.415-0.227-3.835-0.937l0.625-1.278c2.471 1.221 4.261 0.795 6.193 0.312 1.761-0.426 3.608-0.881 5.71 0.227l-0.653 1.25c-1.619-0.852-3.039-0.511-4.687-0.114-1.023 0.284-2.13 0.54-3.352 0.54z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M10.539 20.062c-1.136 0-2.415-0.227-3.835-0.937l0.625-1.278c2.471 1.221 4.261 0.795 6.193 0.312 1.761-0.426 3.608-0.881 5.71 0.227l-0.653 1.25c-1.619-0.852-3.039-0.511-4.687-0.114-1.023 0.256-2.13 0.54-3.352 0.54z' }),
                _react2.default.createElement(Path, { fill: this.props.fill, d: 'M10.539 22.903c-1.136 0-2.415-0.227-3.835-0.937l0.625-1.278c2.471 1.221 4.261 0.795 6.193 0.312 1.761-0.426 3.608-0.881 5.71 0.227l-0.653 1.25c-1.619-0.852-3.039-0.511-4.687-0.114-1.023 0.284-2.13 0.54-3.352 0.54z' })
            );
        }
    }]);

    return DryingMachine;
}(_react2.default.Component);

DryingMachine.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = DryingMachine;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/drying-machine.js
// module id = 1094
// module chunks = 0